import { Box, Button, Flex, Grid, Heading, Image, Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CartridgeModel } from 'src/components/common/CartridgeModel/cartridgeModel';
import { TagSelector } from 'src/components/common/inputs/TagSelector/tagSelector';
import { CenteredHeader } from 'src/components/common/texts/CenteredHeader/centeredHeader';
import { colors } from 'src/utils/colors';
import { availableCategories } from '../SetMetadata/setMetadata';

export const SetTags = () => {
	const { values, setFieldValue } = useFormikContext();

	const { t } = useTranslation();

	return (
		<Flex
			pos="relative"
			p="0px 100px"
			alignItems="center"
			margin="0 auto"
			flexDir="column"
			gap="40px"
			zIndex="0"
			m="-50px 0px"
		>
			<Flex
				flexDirection="column"
				align="center"
				justify="center"
				pos="relative"
				position="relative"
			>
				<CenteredHeader label={t('form.steps.setTags.label')} description={t('form.steps.setTags.description')}>{t('form.steps.setTags.heading')}</CenteredHeader>
				<Flex
					justify="center"
					align="center"
					position="relative"
					mt="40px"
				>
					<TagSelector
						name="tags"
						tags={availableCategories}
					/>
				</Flex>
			</Flex>
		</Flex>
	);
};
